import { useMutation } from '@tanstack/react-query';
import { PermanentJobsService } from '../services';

export const useRetryBilling = () => {
  return useMutation({
    mutationKey: ['retryBilling'],
    mutationFn: PermanentJobsService.retryBilling,
  });
};
